import { Button, Flex, usePlatformProps } from '@acsbe/ui';

export const ContactUsPlanButton = () => {
  const p = usePlatformProps();

  return (
    <Flex
      align="center"
      gap={4}
      self="stretch"
      // {...p.uptoMobile({
      //   stretch: true,
      //   self: 'stretch',
      // })}
    >
      <Button
        fullWidth
        scale="primary"
        variant="secondary"
        aria-describedby="link-context"
        data-mixpanel="contact-us-plan-subscription"
        onClick={() => {
          window.open(
            `${import.meta.env.VITE_DASHBOARD_URL}/?contact-sales=true`,
            '_blank',
          );
        }}
      >
        Contact Us
      </Button>
    </Flex>
  );
};
